class WebRTCService {
  constructor() {
    this.peerConnection = null;
    this.localStream = null;
    this.remoteStream = null;
    this.pendingCandidates = []; 
    this.onRemoteStream = null;
    this.onIceCandidate = null;
    this.onConnectionStateChange = null; 
    
    this.configuration = {
      iceTransportPolicy: "all", 
      iceCandidatePoolSize: 10,  
      iceServers: [
        { urls: 'stun:stun.l.google.com:19302' },
        { 
          urls: "turn:lafabak.info:4433?transport=udp", 
          username: "dubistoncall", 
          credential: "laskdf8349809jf0alsdflökasdf" 
        },
        { 
          urls: "turn:lafabak.info:4433?transport=tcp", 
          username: "dubistoncall", 
          credential: "laskdf8349809jf0alsdflökasdf" 
        }
      ]
    };
  }

  // --- KORRIGIERTE QUEUE LOGIK ---
  async addIceCandidate(candidate) {
    // console.log("🧊 ICE Candidate empfangen:", candidate.type || "unknown");
    
    if (!this.peerConnection) {
      console.warn("⚠️ Kein PeerConnection für ICE Candidate (wird gepuffert)");
      this.pendingCandidates.push(candidate);
      return;
    }
    
    // WICHTIG: Wenn RemoteDescription fehlt, MUSS gepuffert werden!
    if (!this.peerConnection.remoteDescription) {
      // console.log("📝 Remote Description fehlt noch - Candidate in Warteschlange geschoben.");
      this.pendingCandidates.push(candidate);
      return;
    }
    
    try {
      await this.peerConnection.addIceCandidate(new RTCIceCandidate(candidate));
      // console.log("✅ ICE Candidate sofort hinzugefügt");
    } catch (e) { 
      console.warn("❌ ICE Candidate Fehler:", e.message);
    }
  }

  async _flushCandidateQueue() {
    if (this.pendingCandidates.length === 0) return;
    
    // console.log(`🚀 Verarbeite ${this.pendingCandidates.length} wartende ICE Candidates...`);
    const candidates = [...this.pendingCandidates];
    this.pendingCandidates = []; 
    
    for (const candidate of candidates) {
      try { 
        if (this.peerConnection && this.peerConnection.remoteDescription) {
            await this.peerConnection.addIceCandidate(new RTCIceCandidate(candidate));
            // console.log("✅ Wartender Candidate verarbeitet");
        } else {
            console.warn("⚠️ Konnte gepufferten Candidate nicht verarbeiten (PC fehlt immer noch)");
        }
      } catch (e) {
        console.warn("❌ Wartender Candidate Fehler:", e.message);
      }
    }
  }

  // --- PUNKT 3: Robusteres Signaling (Timing) ---
  async createOffer() {
    // console.log("📤 Erstelle Offer...");
    if (!this.peerConnection) this._createPeerConnection();
    const offer = await this.peerConnection.createOffer();
    await this.peerConnection.setLocalDescription(offer);
    // console.log("✅ Local Description (Offer) gesetzt");
    return offer;
  }

  async handleOffer(offer) {
    // console.log("📥 Verarbeite Offer...");
    if (!this.peerConnection) this._createPeerConnection();
    
    try {
      await this.peerConnection.setRemoteDescription(new RTCSessionDescription(offer));
      // console.log("✅ Remote Description (Offer) gesetzt");
      
      // ⚡ JETZT erst die Kandidaten nachladen!
      await this._flushCandidateQueue();
      
      const answer = await this.peerConnection.createAnswer();
      // console.log("📤 Answer erstellt");
      
      await this.peerConnection.setLocalDescription(answer);
      // console.log("✅ Local Description (Answer) gesetzt");
      
      return answer;
    } catch (error) {
      console.error("❌ Offer-Verarbeitung fehlgeschlagen:", error);
      throw error;
    }
  }

  async handleAnswer(answer) {
    // console.log("📥 Verarbeite Answer...");
    if (!this.peerConnection) return;
    
    try {
      await this.peerConnection.setRemoteDescription(new RTCSessionDescription(answer));
      // console.log("✅ Remote Description (Answer) gesetzt");
      
      // ⚡ JETZT erst die Kandidaten nachladen!
      await this._flushCandidateQueue();
    } catch (error) {
      console.error("❌ Answer-Verarbeitung fehlgeschlagen:", error);
      throw error;
    }
  }

  // --- PUNKT 2: Detailliertes Monitoring ---
  _createPeerConnection() {
    // console.log("🛠️ Erstelle neue PeerConnection...");
    try {
        this.peerConnection = new RTCPeerConnection(this.configuration);

        // Connection State
        this.peerConnection.onconnectionstatechange = () => {
            const state = this.peerConnection.connectionState;
            // console.log(`🔗 Connection State: ${state}`);
            if (state === 'connected') {
                // console.log("🎉 Verbindung erfolgreich!");
                setTimeout(() => this.debugAudioState(), 1000);
            }
            if (state === 'failed') console.error("❌ Verbindung gescheitert (Firewall/Netzwerk?)");
            
            if (this.onConnectionStateChange) this.onConnectionStateChange(state);
        };

        // ICE Connection State
        this.peerConnection.oniceconnectionstatechange = () => {
            const state = this.peerConnection.iceConnectionState;
            // console.log(`🧊 ICE Connection State: ${state}`);
        };

        // ICE Gathering State
        this.peerConnection.onicegatheringstatechange = () => {
            // console.log(`❄️ ICE Gathering State: ${this.peerConnection.iceGatheringState}`);
        };

        // Candidates senden
        this.peerConnection.onicecandidate = (event) => {
            if (event.candidate && this.onIceCandidate) {
                this.onIceCandidate(event.candidate);
            }
        };

        // Track Handling (Dein guter Audio-Fix)
        this.peerConnection.ontrack = (event) => {
            // console.log('📡 REMOTE TRACK EMPFANGEN:', event.track.kind, event.streams[0]?.id);

            if (event.track.kind === 'audio') {
                event.track.enabled = true;
                setTimeout(() => {
                    if (event.track.muted) {
                        console.log("🔧 Remote Track muted -> AudioContext Hack...");
                        try {
                            const AudioContext = window.AudioContext || window.webkitAudioContext;
                            const ctx = new AudioContext();
                            const source = ctx.createMediaStreamSource(new MediaStream([event.track]));
                            const dest = ctx.createMediaStreamDestination();
                            source.connect(dest);
                            if(ctx.state === 'suspended') ctx.resume();
                        } catch(e) { console.warn("AudioContext Hack Fehler:", e); }
                    }
                }, 500);
            }

            if (event.streams && event.streams[0]) {
                this.remoteStream = event.streams[0];
            } else {
                if (!this.remoteStream) this.remoteStream = new MediaStream();
                this.remoteStream.addTrack(event.track);
            }

            if (this.onRemoteStream) this.onRemoteStream(this.remoteStream);
        };

    } catch (e) {
        console.error("Fehler PC Erstellung:", e);
    }
  }

  // --- Standard Methoden ---
  resumeAudio() {
    try {
      const AudioContext = window.AudioContext || window.webkitAudioContext;
      if (AudioContext) {
        const ctx = new AudioContext();
        if (ctx.state === 'suspended') ctx.resume();
      }
    } catch (e) {}
  }

  debugAudioState() {
    // console.log("=== 🩺 AUDIO DIAGNOSE ===");
    if (this.remoteStream) {
      this.remoteStream.getAudioTracks().forEach((track, i) => {
        // console.log(`📥 REMOTE Audio ${i}: Enabled=${track.enabled}, Muted=${track.muted}, State=${track.readyState}`);
      });
    }
    // console.log("========================");
  }

  async initializeCall(type = 'video') {
    // console.log(`🚀 initializeCall: ${type}`);
    this.resumeAudio();
    if (!this.peerConnection) this._createPeerConnection();

    try {
      const constraints = { audio: true, video: type === 'video' };
      this.localStream = await navigator.mediaDevices.getUserMedia(constraints);
    } catch (error) {
      console.error("❌ Medien-Fehler:", error);
      if (type === 'video') {
          console.warn("⚠️ Fallback Audio-Only");
          this.localStream = await navigator.mediaDevices.getUserMedia({ audio: true, video: false });
      } else { throw error; }
    }

    if (this.localStream) {
        this.localStream.getAudioTracks().forEach(track => { track.enabled = true; });
        this.localStream.getTracks().forEach(track => this.peerConnection.addTrack(track, this.localStream));
    }
    return this.localStream;
  }

  toggleAudio(muted) { if (this.localStream) this.localStream.getAudioTracks().forEach(t => t.enabled = !muted); }
  toggleVideo(off) { if (this.localStream) this.localStream.getVideoTracks().forEach(t => t.enabled = !off); }
  getLocalStream() { return this.localStream; }
  getRemoteStream() { return this.remoteStream; }

  endCall() {
    if (this.localStream) { this.localStream.getTracks().forEach(t => t.stop()); this.localStream = null; }
    if (this.remoteStream) { this.remoteStream.getTracks().forEach(t => t.stop()); this.remoteStream = null; }
    if (this.peerConnection) { this.peerConnection.close(); this.peerConnection = null; }
    this.pendingCandidates = [];
  }
}

const webRTCService = new WebRTCService();
export default webRTCService;